export const Subtitle: React.FC = ({ children }) => (
  <h4 className="title has-text-weight-bold">{children}</h4>
)